import { Chip } from "@mui/material";
import { BookingStatus } from "src/business/booking";
import { useTranslation } from "react-i18next";
import {
  iconBgSuccess, iconColorSuccess, colorBorderSuccessEmphasis,
  colorDealBg, colorDealAccent, colorDealBorder,
  colorSurfaceDangerHover, colorActionDanger, colorBorderError,
  iconBgInfo, iconColorInfo, colorBorderInfo,
  iconBgPurple, iconColorPurple,
} from "src/design/tokens";

const STATUS_STYLES: Record<BookingStatus, { bg: string; color: string; border: string }> = {
  [BookingStatus.CONFIRMED]: { bg: iconBgSuccess, color: iconColorSuccess, border: colorBorderSuccessEmphasis },
  [BookingStatus.PENDING]: { bg: colorDealBg, color: colorDealAccent, border: colorDealBorder },
  [BookingStatus.CANCELED]: { bg: colorSurfaceDangerHover, color: colorActionDanger, border: colorBorderError },
  [BookingStatus.CHECKED_IN]: { bg: iconBgInfo, color: iconColorInfo, border: colorBorderInfo },
  [BookingStatus.NO_SHOW]: { bg: colorSurfaceDangerHover, color: colorActionDanger, border: colorBorderError },
};

const STATUS_LABEL_KEYS: Record<BookingStatus, string> = {
  [BookingStatus.CONFIRMED]: "bookings.status.confirmed",
  [BookingStatus.PENDING]: "bookings.status.pending",
  [BookingStatus.CANCELED]: "bookings.status.cancelled",
  [BookingStatus.CHECKED_IN]: "bookings.status.checkedIn",
  [BookingStatus.NO_SHOW]: "bookings.status.noShow",
};

interface Props {
  status: BookingStatus;
}

export const BookingStatusBadge = ({ status }: Props) => {
  const { t } = useTranslation();
  const styles = STATUS_STYLES[status] ?? STATUS_STYLES[BookingStatus.PENDING];

  return (
    <Chip
      label={t(STATUS_LABEL_KEYS[status] ?? STATUS_LABEL_KEYS[BookingStatus.PENDING])}
      size="small"
      sx={{
        backgroundColor: styles.bg,
        color: styles.color,
        border: `1px solid ${styles.border}`,
        fontWeight: 500,
        fontSize: "11px",
        height: "20px",
        borderRadius: "6px",
      }}
    />
  );
};
